export function refreshTraceId(email) {
  const traceId = `${email || '?'}-${(Math.random() + 1).toString(36).substring(2)}`// NOSONAR javascript:S2245
  document.cookie = `traceId=${traceId}; path=/; Secure; Domain=.kingpin.global; Max-Age=86400;`
  return traceId
}
